
import { ServiceData } from '@/types/serviceTypes';
import { lawnMaintenanceService } from './serviceDetails/lawnMaintenanceService';
import { hardscapeProjectsService } from './serviceDetails/hardscapeProjectsService';
import { landscapeDesignService } from './serviceDetails/landscapeDesignService';
import { snowRemovalService } from './serviceDetails/snowRemovalService';

export const serviceData: Record<string, ServiceData> = {
  'lawn-maintenance': lawnMaintenanceService,
  'hardscape-projects': hardscapeProjectsService,
  'landscape-design': landscapeDesignService,
  'snow-removal': snowRemovalService,
  // More services would be added here as needed
};
